const SupportTicket = () => {
  return (
    <div>
      <div className="content-wrapper">
        <iframe
          src="https://chatbot.nationalroadsafetymission.org/admin/tickets"
          width="100%"
          height="600px"
          style={{ border: "none" }}
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
};

export default SupportTicket;
